let collectionRequestInProgress = false;
let collectionScrollTimeout = null;

async function scrollExecute() {
  const distanceFromBottom =
    document.documentElement.scrollHeight -
    (window.scrollY + window.innerHeight);

  if (distanceFromBottom > 800) return;
  if (collectionRequestInProgress) return;

  const moreLink = document.querySelector('a#more');
  const currentGrid = document.querySelector('#product-grid');
  const loader = document.querySelector('#loader');

  if (!moreLink || !moreLink.href || !currentGrid) return;

  collectionRequestInProgress = true;

  if (loader) {
    loader.classList.remove('hidden');
  }

  try {
    const response = await fetch(moreLink.href, {
      method: 'GET',
      headers: {
        Accept: 'text/html',
        'X-Requested-With': 'XMLHttpRequest'
      }
    });

    if (!response.ok) {
      throw new Error(
        `Unable to load products: ${response.status}`
      );
    }

    const responseText = await response.text();

    const nextDocument = new DOMParser().parseFromString(
      responseText,
      'text/html'
    );

    const nextGrid =
      nextDocument.querySelector('#product-grid');

    if (!nextGrid) {
      throw new Error('Next product grid was not found.');
    }

    const newProducts = Array.from(
      nextGrid.children
    ).filter((item) =>
      item.classList.contains('grid__item')
    );

    const fragment = document.createDocumentFragment();

    newProducts.forEach((product) => {
      product.classList.remove(
        'scroll-trigger',
        'animate--slide-in',
        'scroll-trigger--offscreen'
      );

      product.removeAttribute('data-cascade');
      product.style.removeProperty('--animation-order');

      fragment.appendChild(product);
    });

    currentGrid.appendChild(fragment);

    const nextMoreLink =
      nextDocument.querySelector('a#more');

    if (nextMoreLink?.href) {
      moreLink.href = nextMoreLink.href;
    } else {
      moreLink.remove();
    }

    document.dispatchEvent(
      new CustomEvent('collection:products-loaded', {
        detail: {
          productsAdded: newProducts.length
        }
      })
    );

    if (window.Shopify?.PaymentButton) {
      window.Shopify.PaymentButton.init();
    }
  } catch (error) {
    console.error('Infinite scroll error:', error);
  } finally {
    collectionRequestInProgress = false;

    if (loader) {
      loader.classList.add('hidden');
    }

    const distanceAfterLoading =
      document.documentElement.scrollHeight -
      (window.scrollY + window.innerHeight);

    if (
      distanceAfterLoading <= 800 &&
      document.querySelector('a#more')
    ) {
      window.setTimeout(scrollExecute, 200);
    }
  }
}

function initializeCollectionInfiniteScroll() {
  window.addEventListener(
    'scroll',
    () => {
      window.clearTimeout(collectionScrollTimeout);

      collectionScrollTimeout = window.setTimeout(
        scrollExecute,
        200
      );
    },
    { passive: true }
  );

  scrollExecute();
}

if (document.readyState === 'loading') {
  document.addEventListener(
    'DOMContentLoaded',
    initializeCollectionInfiniteScroll
  );
} else {
  initializeCollectionInfiniteScroll();
}